import { ColumnState } from 'ag-grid-community';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { UserResponseDto } from 'src/dtos/user/response/userResponseDto';
import { create } from 'zustand';
import { defaultKSK2030_R01DetailDto, defaultKSK2030_R01Dto, KSK2030_R01DetailDto, KSK2030_R01Dto } from './Dto_KSK2030_R01';
import { DateRange } from 'react-day-picker';
import { getUserSearchFilterDefaults } from 'src/hooks/useInitUserSearchFilter';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';

export interface KSK2030_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	workplaceCd: string;
	jobTeam: string;
	closeTag: string;
	orderEmp: string;
	orderEmpNm: string;
}

export interface Store_KSK2030_R01 {
	KSK2030_R01Filter: KSK2030_R01Filter;
	KSK2030_R01PastFilter: KSK2030_R01Filter;
	setKSK2030_R01Filter: (filter: Partial<KSK2030_R01Filter>) => void;
	setKSK2030_R01PastFilter: (filter: Partial<KSK2030_R01Filter>) => void;

    KSK2030_R01List: KSK2030_R01Dto[];
    setKSK2030_R01List: (userList: KSK2030_R01Dto[]) => void;
    insertKSK2030_R01List: (data: KSK2030_R01Dto[], index?: number) => void;
    removeKSK2030_R01List: (index: number) => void;
    updateKSK2030_R01List: (index: number, data: KSK2030_R01Dto) => void;
	
	editKSK2030_R01: KSK2030_R01Dto | null;
	setEditKSK2030_R01: (editHeader: KSK2030_R01Dto | null) => void;	

    deletedKSK2030_R01List: string[];
    addDeletedKSK2030_R01List: (idList: string[]) => void;
    removeDeletedKSK2030_R01List: (idList?: string[]) => void;

	selectedKSK2030_R01: KSK2030_R01Dto | undefined;
	setSelectedKSK2030_R01: (data: KSK2030_R01Dto | undefined) => void;
	initSelectedKSK2030_R01: () => void;

	originalKSK2030_R01List: KSK2030_R01Dto[];
	setOriginalKSK2030_R01List: (list: KSK2030_R01Dto[]) => void;


    KSK2030_R01DetailList: KSK2030_R01DetailDto[];
    setKSK2030_R01DetailList: (userList: KSK2030_R01DetailDto[]) => void;
    insertKSK2030_R01DetailList: (data: KSK2030_R01DetailDto[], index?: number) => void;
    removeKSK2030_R01DetailList: (index: number) => void;
    updateKSK2030_R01DetailList: (index: number, data: KSK2030_R01DetailDto) => void;

	deletedKSK2030_R01DetailList: string[];
    addDeletedKSK2030_R01DetailList: (idList: string[]) => void;
    removeDeletedKSK2030_R01DetailList: (idList?: string[]) => void;

	selectedKSK2030_R01DetailList: KSK2030_R01DetailDto;
	setSelectedKSK2030_R01DetailList: (data: KSK2030_R01DetailDto) => void;
	initSelectedKSK2030_R01DetailList: () => void;

	originalKSK2030_R01DetailList: KSK2030_R01DetailDto[];
	setOriginalKSK2030_R01DetailList: (data: KSK2030_R01DetailDto[]) => void;

    columnState: ColumnState[] | null;			setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	modalVisible: boolean;				setModalVisible: (modalVisible: boolean) => void;
	
	isDisabled: (data: KSK2030_R01Dto) => boolean;

    initData: () => void;


}

export const createDefaultKSK2030_R01Filter = (): KSK2030_R01Filter => ({
	...getUserSearchFilterDefaults(),
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: getFutureWeekdayExceptTodayAndTomorrow()
	},
	jobTeam: '',
	closeTag: 'N',
	orderEmp: '',
	orderEmpNm: '',
});

export const defaultKSK2030_R01Filter: KSK2030_R01Filter = createDefaultKSK2030_R01Filter();

export const useKSK2030_R01Store = create<Store_KSK2030_R01>((set) => ({
	KSK2030_R01Filter: defaultKSK2030_R01Filter,
	KSK2030_R01PastFilter: defaultKSK2030_R01Filter,
	setKSK2030_R01PastFilter: (filter: Partial<KSK2030_R01Filter>) => set((state) => ({
		...state,
		KSK2030_R01PastFilter: { ...state.KSK2030_R01PastFilter, ...filter }
	})),
	setKSK2030_R01Filter: (filter: Partial<KSK2030_R01Filter>) => set((state) => ({
		...state,
		KSK2030_R01Filter: { ...state.KSK2030_R01Filter, ...filter }
	})),

    KSK2030_R01List: [],
    setKSK2030_R01List: (KSK2030_R01List: KSK2030_R01Dto[]) => set((state) => {
		let newList: KSK2030_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		KSK2030_R01List.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultKSK2030_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2030_R01List: newList
		}
	}),
	insertKSK2030_R01List: (data: KSK2030_R01Dto[], index?: number) => set((state) => {
		let newKSK2030_R01List = [...state.KSK2030_R01List];

		let targetRowData = newKSK2030_R01List.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2030_R01List.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2030_R01List.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2030_R01List = newKSK2030_R01List.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2030_R01List.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2030_R01Dto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2030_R01List.splice(index, 0, ...newData);
		} else {
			newKSK2030_R01List.push(...newData);
		}		

		return {
			...state,
			KSK2030_R01List: newKSK2030_R01List
		}
	}),
	removeKSK2030_R01List: (index: number) => set((state) => {
		const newKSK2030_R01List = [...state.KSK2030_R01List].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2030_R01List: newKSK2030_R01List
		}
	}),
	updateKSK2030_R01List: (valueIndex: number, data: KSK2030_R01Dto) => set((state) => {
		const _KSK2030_R01List = state.KSK2030_R01List.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.orderQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.orderQty = 0;
		}
		return {
			...state,
			KSK2030_R01List: _KSK2030_R01List
		}
	}),

	editKSK2030_R01: defaultKSK2030_R01Dto,
	setEditKSK2030_R01: (editHeader: KSK2030_R01Dto | null) => set((state) => ({
		...state,
		editKSK2030_R01: editHeader
	})),

	selectedKSK2030_R01: undefined,
	setSelectedKSK2030_R01: (data: KSK2030_R01Dto | undefined) => set({ selectedKSK2030_R01: data }),
	initSelectedKSK2030_R01: () => set({ selectedKSK2030_R01: undefined }),

    deletedKSK2030_R01List: [],
    addDeletedKSK2030_R01List: (idList: string[]) => set((state) => {
        const _deletedUserList = [...state.deletedKSK2030_R01List];
		
		for(const valueIndex of idList) {
			const isInserted = state.KSK2030_R01List.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2030_R01List.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedUserList.push(valueIndex);
			}
		}

        return {
            ...state,
            deletedKSK2030_R01List: _deletedUserList
        }
    }),
    removeDeletedKSK2030_R01List: (idList?: string[]) => set((state) => ({
        ...state,
        deletedKSK2030_R01List: [...state.deletedKSK2030_R01List].filter(value => idList ? !idList.includes(value) : false)
    })),

	originalKSK2030_R01List: [],
    setOriginalKSK2030_R01List: (KSK2030_R01List: KSK2030_R01Dto[]) => set((state) => {
		let newList: KSK2030_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		KSK2030_R01List.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2030_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2030_R01List: newList
		}
	}),

	KSK2030_R01DetailList: [],
    setKSK2030_R01DetailList: (KSK2030_R01DetailList: KSK2030_R01DetailDto[]) => set((state) => {
		let newList: KSK2030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		KSK2030_R01DetailList.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				...defaultKSK2030_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2030_R01DetailList: newList
		}
	}),
	insertKSK2030_R01DetailList: (data: KSK2030_R01DetailDto[], index?: number) => set((state) => {
		let newKSK2030_R01DetailList = [...state.KSK2030_R01DetailList];

		let targetRowData = newKSK2030_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2030_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01DetailList에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2030_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01DetailList에 대체
		newKSK2030_R01DetailList = newKSK2030_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2030_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2030_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2030_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK2030_R01DetailList.push(...newData);
		}		

		return {
			...state,
			KSK2030_R01DetailList: newKSK2030_R01DetailList
		}
	}),
	removeKSK2030_R01DetailList: (index: number) => set((state) => {
		const newKSK2030_R01DetailList = [...state.KSK2030_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2030_R01DetailList: newKSK2030_R01DetailList
		}
	}),
	updateKSK2030_R01DetailList: (valueIndex: number, data: KSK2030_R01DetailDto) => set((state) => {
		const _KSK2030_R01DetailList = state.KSK2030_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			KSK2030_R01DetailList: _KSK2030_R01DetailList
		}
	}),

	
    deletedKSK2030_R01DetailList: [],
    addDeletedKSK2030_R01DetailList: (idList: string[]) => set((state) => {
        const _deletedUserList = [...state.deletedKSK2030_R01DetailList];
		
		for(const valueIndex of idList) {
			const isInserted = state.KSK2030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2030_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedUserList.push(valueIndex);
			}
		}

        return {
            ...state,
            deletedKSK2030_R01DetailList: _deletedUserList
        }
    }),
    removeDeletedKSK2030_R01DetailList: (idList?: string[]) => set((state) => ({
        ...state,
        deletedKSK2030_R01DetailList: [...state.deletedKSK2030_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
    })),

	selectedKSK2030_R01DetailList: defaultKSK2030_R01DetailDto,
	setSelectedKSK2030_R01DetailList: (data: KSK2030_R01DetailDto) => set((state) => {
		return {
			...state,
			selectedKSK2030_R01DetailList: data
		}
	}),
	initSelectedKSK2030_R01DetailList: () => set({ selectedKSK2030_R01DetailList: defaultKSK2030_R01DetailDto }),

	originalKSK2030_R01DetailList: [],
    setOriginalKSK2030_R01DetailList: (KSK2030_R01DetailList: KSK2030_R01DetailDto[]) => set((state) => {
		let newList: KSK2030_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		KSK2030_R01DetailList.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2030_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2030_R01DetailList: newList
		}
	}),

    columnState: null,			    setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,		setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,				setAllCount: (allCount: number) => set({ allCount }),
	modalVisible: false,		setModalVisible: (modalVisible: boolean) => set({ modalVisible }),
					
	isDisabled: (data: KSK2030_R01Dto) => data.closeTag === 'Y' || data.resultQty > 0,

    initData: () => set((state) => ({
        ...state,
		KSK2030_R01Filter: createDefaultKSK2030_R01Filter(),
		KSK2030_R01PastFilter: createDefaultKSK2030_R01Filter(),
		KSK2030_R01Info: undefined,
        KSK2030_R01List: [],
        selectedKSK2030_R01List: [],
        deletedKSK2030_R01List: [],
		KSK2030_R01DetailList: [],
		deletedKSK2030_R01DetailList: [],
		allCount: 0
    }))
}));